import axionIns from "../axios";

const getSingleCampaignDetail = (campaignId, page, limit, search, status) => {
  return axionIns.get(`admin/peopleai/campaign/${campaignId}?page=${page}&perPage=${limit}&search=${search}&status=${status}`).then((response) => {
    return response.data;
  });
};

const getCampaignList = (page,
  limit,
  search,
  status) => {
  return axionIns.get(`admin/peopleai/campaign?page=${page}&perPage=${limit}&search=${search}&status=${status}`).then((response) => {
    return response.data;
  });
};

const getProfileById = (id) => {
  return axionIns.get(`admin/campaignprofile/${id}`).then((response) => {
    return response.data;
  });
};


const reviewCampaign = (campaignid) => {
  let endpoint = `admin/peopleai/campaign/launch/${campaignid}`
  return axionIns.put(endpoint).then((response) => {
    return response.data;
  });
};

const addProfileToCampaign = (payload) => {
  return axionIns.post("admin/peopleai/campaign/profile", payload).then((response) => {
    return response.data;
  });
};

const exportObject = { getSingleCampaignDetail, getCampaignList, getProfileById, reviewCampaign, addProfileToCampaign };
export default exportObject;
